export default "__VITE_ASSET__Bcij8vKy__"